import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";
import $ from "jquery";

import { Translate, I18n } from "react-redux-i18n";

import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import ToggleSwitch from "../../utils/components/ToggleSwitch";

import { setAlert } from "../../../actions/alertActions";
import { getPlug } from "../../utils/Utils";

import arrow from "../../../styles/images/arrow_black.svg";
import "../../../styles/components/chargers/modals/ConfigurePlug.scss";

class ConfigurePlug extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      validated: false,
      isScrolled: false,
      accordionToggles: [true],

      selectedCharger: null,
      selectedPlug: null,
      plugs: getPlug("all"),
      enableSwitch: false,
      current: 0,
      voltage: 0,
      power: 0,
    };

    this.handleScroll = this.handleScroll.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleOnClickAccordion = this.handleOnClickAccordion.bind(this);
    this.handleOnSubmit = this.handleOnSubmit.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.hasOwnProperty("selectedCharger") &&
      this.props.selectedCharger
    )
      if (
        prevProps.selectedCharger !== this.props.selectedCharger ||
        prevProps.selectedCharger._id !== this.props.selectedCharger._id
      )
        this.safeSetState({
          selectedCharger: this.props.selectedCharger,
        });

    if (this.props.hasOwnProperty("selectedPlug") && this.props.selectedPlug)
      if (
        prevProps.selectedPlug !== this.props.selectedPlug ||
        prevProps.selectedPlug.plugId !== this.props.selectedPlug.plugId
      ) {
        let plugChoosenIndex = null;

        Object.keys(this.state.plugs).forEach((k) => {
          if (
            this.state.plugs[k].name === this.props.selectedPlug.connectorType
          )
            plugChoosenIndex = k;
        });

        if (plugChoosenIndex) {
          this.onPlugClick(plugChoosenIndex);
          this.safeSetState({
            selectedPlug: this.props.selectedPlug,
            current:
              Number(this.props.selectedPlug.amperage) > 0
                ? this.props.selectedPlug.amperage
                : null,
            voltage:
              Number(this.props.selectedPlug.voltage) > 0
                ? this.props.selectedPlug.voltage
                : null,
            power:
              Number(this.props.selectedPlug.power) > 0
                ? this.props.selectedPlug.power
                : null,
            enableSwitch: this.props.selectedPlug.active
              ? this.props.selectedPlug.active
              : false,
          });
        } else
          this.safeSetState({
            selectedPlug: this.props.selectedPlug,
            current:
              Number(this.props.selectedPlug.amperage) > 0
                ? this.props.selectedPlug.amperage
                : null,
            voltage:
              Number(this.props.selectedPlug.voltage) > 0
                ? this.props.selectedPlug.voltage
                : null,
            power:
              Number(this.props.selectedPlug.power) > 0
                ? this.props.selectedPlug.power
                : null,
            enableSwitch: this.props.selectedPlug.active
              ? this.props.selectedPlug.active
              : false,
          });
      }

    if (
      this.props.hasOwnProperty("tabIndex") &&
      !Number.isNaN(this.props.tabIndex)
    )
      if (prevState.tabIndex !== this.props.tabIndex)
        this.safeSetState({ tabIndex: this.props.tabIndex });
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  handleScroll(e) {
    this.safeSetState({
      isScrolled: e.target.scrollTop > 0 ? true : false,
    });
  }

  handleOnChange(e) {
    this.safeSetState({
      [e.target.name]: e.target.value,
    });
  }

  handleOnClickAccordion(e) {
    let toggles = [false, false];
    toggles[$(e.target).parent(".card").index()] =
      !this.state.accordionToggles[$(e.target).parent(".card").index()];
    this.safeSetState({ accordionToggles: toggles });
  }

  validateForm() {
    let plugChoosenIndex = null;

    Object.keys(this.state.plugs).forEach((k) => {
      if (this.state.plugs[k].picked) plugChoosenIndex = k;
    });

    return (
      this.state.enableSwitch !== null &&
      plugChoosenIndex !== null &&
      Number(this.state.power) > 0 &&
      Number(this.state.current) > 0 &&
      Number(this.state.voltage) > 0
    );
  }

  handleOnSubmit(e) {
    e.preventDefault();
    if (this.validateForm() === true) {
      let plugChoosen = null;

      Object.keys(this.state.plugs).forEach((k) => {
        if (this.state.plugs[k].picked) plugChoosen = k;
      });

      const patch = {
        _id: this.state.selectedCharger.chargerId,
        plugs: [
          {
            plugId: this.state.selectedPlug.plugId,
            amperage: this.state.current,
            voltage: this.state.voltage,
            power: this.state.power,
            connectorType: plugChoosen,
            active: this.state.enableSwitch,
          },
        ],
      };
      axios
        .patch("/api/private/chargers/configPlugs", patch, {
          cancelToken: new CancelToken((c) => (this.cancel = c)),
        })
        .then((res) => {
          if (res.status === 200) {
            this.props.setAlert(
              I18n.t("chargers_configurePlug_submitSuccess"),
              "primary"
            );
            this.props.onSuccess();
          }
        })
        .catch((err) => {
          if (err.response && err.response.data)
            this.props.setAlert(I18n.t(err.response.data.message), "danger");
          if (axios.isCancel(err)) console.log("axios", err);
          else console.log(err);
        });
    } else {
      this.props.setAlert(
        I18n.t("chargers_configurePlug_submitUnSuccess"),
        "danger"
      );
    }
  }

  isNumber(n) {
    return (Number(n) === n && n % 1 !== 0) || (Number(n) === n && n % 1 === 0);
  }

  onPlugClick(plug) {
    this.safeSetState(
      {
        plugs: getPlug("all"),
      },
      () =>
        this.safeSetState((prevState) => ({
          plugs: Object.assign({}, prevState.plugs, {
            [plug]: Object.assign({}, prevState.plugs[plug], {
              picked: !prevState.plugs[plug].picked,
            }),
          }),
        }))
    );
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <>
        <Modal
          id="configurePlug"
          show={this.props.show}
          onHide={this.props.onHide}
          onExited={this.resetState}
          centered
        >
          <Modal.Header>
            <Modal.Title>
              <Translate value="chargers_configurePlug_title" />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body onScroll={this.handleScroll}>
            <Form
              id="charger-form"
              noValidate
              validated={this.state.validated}
              onSubmit={this.handleOnSubmit}
            >
              <Accordion defaultActiveKey="0">
                <Form.Group
                  as={Card}
                  controlId="plug-type"
                  className="form-field"
                >
                  <Accordion.Toggle
                    as={Card.Header}
                    eventKey="0"
                    onClick={this.handleOnClickAccordion}
                  >
                    <Translate value="chargers_configurePlug_plugType" />
                    <Form.Control
                      as="div"
                      isInvalid={
                        Object.values(this.state.plugs).findIndex(
                          (p) => p.picked === true
                        ) === -1
                      }
                      isValid={
                        Object.values(this.state.plugs).findIndex(
                          (p) => p.picked === true
                        ) !== -1
                      }
                      className="preview-icons"
                    >
                      {this.state.plugs &&
                        Object.keys(this.state.plugs).map((k) => {
                          return (
                            this.state.plugs[k].picked && (
                              <img
                                key={this.state.plugs[k].name + k}
                                src={this.state.plugs[k].plug}
                                alt=""
                              />
                            )
                          );
                        })}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      <Translate value="chargers_configurePlug_invalidPlugType" />
                    </Form.Control.Feedback>
                    <img
                      src={arrow}
                      alt=""
                      className={
                        this.state.accordionToggles[0] ? "arrow open" : "arrow"
                      }
                    />
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="0">
                    <Card.Body>
                      <div className="parking-container">
                        {this.state.plugs &&
                          Object.keys(this.state.plugs).map((k) => (
                            <div
                              key={"parking" + k}
                              className="type-btn"
                              onClick={() => this.onPlugClick(k)}
                            >
                              <img
                                src={
                                  this.state.plugs[k].picked
                                    ? this.state.plugs[k].selected
                                    : this.state.plugs[k].plug
                                }
                                alt=""
                              />
                              <p>{this.state.plugs[k].name}</p>
                            </div>
                          ))}
                      </div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Form.Group>
              </Accordion>

              <Form.Group className="form-field" controlId="plugChargingInfo">
                <Form.Label>
                  <Translate value="chargers_configurePlug_chargingInfo" />
                </Form.Label>
                <Form.Control.Feedback type="invalid">
                  <Translate value="chargers_configurePlug_invalidPlugInfo" />
                </Form.Control.Feedback>
                <div className="charging-info-container">
                  <div className="item">
                    <Form.Control
                      type="text"
                      name="current"
                      value={this.state.current}
                      onChange={this.handleOnChange}
                      isInvalid={!Number(this.state.current)}
                      isValid={Number(this.state.current)}
                      required
                    />
                    <span>
                      <Translate value="chargers_configurePlug_amperage" />
                    </span>
                  </div>
                  <div className="item">
                    <Form.Control
                      type="text"
                      name="voltage"
                      value={this.state.voltage}
                      onChange={this.handleOnChange}
                      isInvalid={!Number(this.state.voltage)}
                      isValid={Number(this.state.voltage)}
                      required
                    />
                    <span>
                      <Translate value="chargers_configurePlug_voltage" />
                    </span>
                  </div>
                  <div className="item">
                    <Form.Control
                      type="text"
                      name="power"
                      value={this.state.power}
                      onChange={this.handleOnChange}
                      isInvalid={!Number(this.state.power)}
                      isValid={Number(this.state.power)}
                      required
                    />
                    <span>
                      <Translate value="chargers_configurePlug_Power" />
                    </span>
                  </div>
                </div>
              </Form.Group>

              <div className="form-field">
                <ToggleSwitch
                  name="chargerBooking"
                  label={
                    <Translate value="chargers_configurePlug_enableSwicth" />
                  }
                  checked={this.state.enableSwitch}
                  onChange={() =>
                    this.safeSetState((prevState) => ({
                      enableSwitch: !prevState.enableSwitch,
                    }))
                  }
                />
              </div>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <button type="submit" form="charger-form">
              <Translate value="myChargersNewCharger_save" />
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default connect(null, { setAlert })(ConfigurePlug);
